import officeApiExecAsync from './infrastructure/office-api-exec-async'
import officeApiGetAsync from './infrastructure/office-api-get-async'

export async function officeApiItem_GetItemIdAsync(): Promise<string> {
  return officeApiGetAsync(
    '1.8',
    'getItemIdAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.item.getItemIdAsync(resolve)),
    null,
  )
}

export async function officeApiItem_SaveAsync(): Promise<string> {
  // eslint-disable-next-line prettier/prettier
  return officeApiGetAsync(
    '1.3',
    'saveAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.item.saveAsync(resolve)),
  )
}

export async function officeApiItem_SubjectGetAsync(): Promise<string> {
  return officeApiGetAsync(
    '1.1',
    'subject.getAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.item.subject.getAsync(resolve)),
    null,
  )
}

export async function officeApiItem_SubjectSetAsync(subject: string): Promise<boolean> {
  return officeApiExecAsync(
    '1.1',
    'subject.setAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.subject.setAsync(subject, resolve)),
  )
}

export async function officeApiItem_AttachmentsGetAsync(): Promise<Office.AttachmentDetailsCompose[]> {
  return officeApiGetAsync(
    '1.8',
    'getAttachmentsAsync',
    () => new Promise<Office.AsyncResult<Office.AttachmentDetailsCompose[]>>((resolve) => Office.context.mailbox.item.getAttachmentsAsync(resolve)),
    [],
  )
}

export async function officeApiItem_AttachmentsGetContentsAsync(id: string): Promise<Office.AttachmentContent> {
  return officeApiGetAsync(
    '1.8',
    'getAttachmentContentAsync',
    () => new Promise<Office.AsyncResult<Office.AttachmentContent>>((resolve) => Office.context.mailbox.item.getAttachmentContentAsync(id, resolve)),
  )
}

export async function officeApiItem_GetAsFileAsync(): Promise<string> {
  return officeApiGetAsync(
    '1.14',
    'getAsFileAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.item.getAsFileAsync(resolve)),
  )
}

export async function officeApiItem_CategoriesGetAsync(): Promise<Office.CategoryDetails[]> {
  return officeApiGetAsync(
    '1.8',
    'categories.getAsync',
    () => new Promise<Office.AsyncResult<Office.CategoryDetails[]>>((resolve) => Office.context.mailbox.item.categories.getAsync(resolve)),
    [],
  )
}

export async function officeApiItem_CategoriesAddAsync(categories: string[]): Promise<boolean> {
  return officeApiExecAsync(
    '1.8',
    'categories.addAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.categories.addAsync(categories, resolve)),
  )
}

export async function officeApiItem_CategoriesRemoveAsync(categories: string[]): Promise<boolean> {
  return officeApiExecAsync(
    '1.8',
    'categories.removeAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.categories.removeAsync(categories, resolve)),
  )
}

export async function officeApiItem_SharedPropertiesLoadAsync(): Promise<Office.SharedProperties> {
  return officeApiGetAsync(
    '1.8',
    'getSharedPropertiesAsync',
    () => new Promise<Office.AsyncResult<Office.SharedProperties>>((resolve) => Office.context.mailbox.item.getSharedPropertiesAsync(resolve)),
    null,
  )
}

export async function officeApiItem_CustomPropertiesLoadAsync(): Promise<Office.CustomProperties> {
  return officeApiGetAsync(
    '1.1',
    'loadCustomPropertiesAsync',
    () => new Promise<Office.AsyncResult<Office.CustomProperties>>((resolve) => Office.context.mailbox.item.loadCustomPropertiesAsync(resolve)),
    null,
  )
}

export async function officeApiItem_CustomPropertiesSaveAsync(props: Office.CustomProperties): Promise<boolean> {
  // eslint-disable-next-line prettier/prettier
  return officeApiExecAsync(
    '1.1',
    'loadCustomPropertiesAsync',
    () => new Promise((resolve) => props.saveAsync(resolve))
  )
}

export async function officeApiItem_AddHandlerAsync(eventType: Office.EventType, handler: any): Promise<boolean> {
  return officeApiExecAsync(
    '1.7',
    'addHandlerAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.addHandlerAsync(eventType, handler, resolve)),
  )
}

export async function officeApiItem_RemoveHandlerAsync(eventType: Office.EventType): Promise<boolean> {
  return officeApiExecAsync(
    '1.7',
    'removeHandlerAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.removeHandlerAsync(eventType, resolve)),
  )
}

// Only gets value on web client compose
export async function officeApiItem_GetConversationIndexAsync(): Promise<string> {
  return officeApiGetAsync(
    '1.8',
    'getConversationIndexAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.item.getConversationIndexAsync(resolve)),
    '',
  )
}
